var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"},on:{"click":_vm.clickDiv}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e(),_c('div',{attrs:{"id":"viewer"}}),_c('div',{staticStyle:{"position":"absolute","top":"-4000px"},attrs:{"id":"htmlContainer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }